/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { relativePrioritySchema } from './relativePrioritySchema';

export const patchItemRequestSchema = z.object({
  deadlineDateTime: z.iso.datetime().nullish(),
  description: z.string().nullish(),
  descriptionSyncSkipped: z.boolean().nullish(),
  doneDateTime: z.iso.datetime().nullish(),
  earliestStartDateTime: z.iso.datetime().nullish(),
  estimationId: z.int().nullish(),
  externalCreatedAt: z.iso.datetime().nullish(),
  externalKey: z.string().nullish(),
  externalLink: z.string().nullish(),
  itemStatusId: z.int().nullish(),
  itemTypeId: z.int().nullish(),
  name: z.string().nullish(),
  parentId: z.int().nullish(),
  plannedFinishDateTime: z.iso.datetime().nullish(),
  plannedStartDateTime: z.iso.datetime().nullish(),
  get relativePriority() {
    return relativePrioritySchema.nullish();
  },
  schedulingType: z.enum(['ACTUALS_ONLY', 'PLANNED_AND_ACTUALS']).nullish(),
  teamId: z.int().nullish(),
  timeSpentSeconds: z.int().nullish(),
});
